import React, { useEffect, useState } from 'react';
import { resolveAvatarUrl } from '../../utils/resolveAvatarUrl';

const Silhouette = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 12C14.76 12 17 9.76 17 7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7C7 9.76 9.24 12 12 12Z" fill="var(--avatar-fallback-fg)" />
    <path d="M12 14C7.58 14 4 16.69 4 20V22H20V20C20 16.69 16.42 14 12 14Z" fill="var(--avatar-fallback-fg)" />
  </svg>
);

const readPhotoUrl = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return resolveAvatarUrl(u?.photo_url) || null;
  } catch {
    return null;
  }
};

/**
 * The bottom-nav "Profile" avatar, shared across all roles. Shows the user's
 * uploaded profile photo (from `localStorage.user.photo_url`) and falls back to
 * a neutral silhouette when there is no photo or the image fails to load.
 * The ring is shown in `activeColor` only while the Profile tab is active.
 * Re-reads the photo live on cross-tab `storage` changes and after an in-app
 * upload (`allure:profile-photo-updated`).
 */
export const NavProfileAvatar = ({ isActive, activeColor = 'var(--accent-purple)', size = 32 }) => {
  const [photoUrl, setPhotoUrl] = useState(readPhotoUrl);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    const refresh = () => {
      setErrored(false);
      setPhotoUrl(readPhotoUrl());
    };
    window.addEventListener('storage', refresh);
    window.addEventListener('allure:profile-photo-updated', refresh);
    return () => {
      window.removeEventListener('storage', refresh);
      window.removeEventListener('allure:profile-photo-updated', refresh);
    };
  }, []);

  const showImage = Boolean(photoUrl) && !errored;

  return (
    <div
      data-testid="nav-profile-avatar"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: 'var(--avatar-fallback-bg)',
        border: isActive ? `2px solid ${activeColor}` : '2px solid transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {showImage ? (
        <img
          src={photoUrl}
          alt="Profile"
          data-testid="nav-profile-avatar-img"
          onError={() => setErrored(true)}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <Silhouette />
      )}
    </div>
  );
};

export default NavProfileAvatar;
